import { render, staticRenderFns } from "./LightIntro.vue?vue&type=template&id=0099efb0"
import script from "./LightIntro.vue?vue&type=script&lang=js"
export * from "./LightIntro.vue?vue&type=script&lang=js"
import style0 from "./LightIntro.vue?vue&type=style&index=0&id=0099efb0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports